import { useGlobalState } from '../../App/globalState';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';
import enTerms from './en';
import hyTerms from './hy';
import TermsConditionsWrapper from './style/termsConditionsWrapper';

const termsTranslations = {
  en: enTerms,
  hy: hyTerms,
};

const TermsAndConditions = () => {
  const { globalState } = useGlobalState();
  const { language } = globalState;
  const terms = termsTranslations[language];

  return (
    <TermsConditionsWrapper>
      <Title size='LG' className='page-title'>
        {terms.title}
      </Title>

      <div className='introduction'>
        {terms.introduction.map((paragraph, index) => (
          <Text size='SM' key={index}>
            {paragraph}
          </Text>
        ))}
      </div>

      {terms.sections.map((section) => (
        <section key={section.id} className='terms-section'>
          <Title size='MD'>{section.heading}</Title>

          <div className='terms-section-text'>
            {section.paragraphs.map((paragraph, index) => (
              <Text size='MD' key={index}>
                {paragraph}
              </Text>
            ))}
          </div>
        </section>
      ))}
    </TermsConditionsWrapper>
  );
};

export default TermsAndConditions;
